import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

// Auth
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';

// Components
import Layout from './components/Layout';

// Pages
import AddResource from './pages/AddResource';
import AdminWaitlist from './pages/AdminWaitlist';
import CreateReservation from './pages/CreateReservation';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import MyWaitlist from './pages/MyWaitlist';
import ReservationDetails from './pages/ReservationDetails';
import Reservations from './pages/Reservations';
import ResourceDetails from './pages/ResourceDetails';
import ResourceRules from './pages/ResourceRules';
import Resources from './pages/Resources';
import Users from './pages/Users';

// Theme
const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
    background: { default: '#f5f5f5' },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* Protected routes */}
              <Route path="/" element={<Navigate to="/resources" replace />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/resources" element={
                <ProtectedRoute>
                  <Layout>
                    <Resources />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/resources/new" element={
                <ProtectedRoute requireAdmin={true}>
                  <Layout>
                    <AddResource />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/resources/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <ResourceDetails />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/resources/:id/reserve" element={
                <ProtectedRoute>
                  <Layout>
                    <CreateReservation />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/reservations" element={
                <ProtectedRoute>
                  <Layout>
                    <Reservations />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/reservations/new" element={
                <ProtectedRoute>
                  <Layout>
                    <CreateReservation />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/reservations/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <ReservationDetails />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/my-waitlist" element={
                <ProtectedRoute>
                  <Layout>
                    <MyWaitlist />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/admin/waitlist" element={
                <ProtectedRoute requireAdmin={true}>
                  <Layout>
                    <AdminWaitlist />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute requireAdmin={true}>
                  <Layout>
                    <Users />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/users/:id/reservations" element={
                <ProtectedRoute>
                  <Layout>
                    <Reservations />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/resource-rules" element={
                <ProtectedRoute>
                  <Layout>
                    <ResourceRules />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
